import { render, staticRenderFns } from "./googleAnalytics.vue?vue&type=template&id=126fa146&scoped=true&"
import script from "./googleAnalytics.vue?vue&type=script&lang=js&"
export * from "./googleAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./googleAnalytics.vue?vue&type=style&index=0&id=126fa146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126fa146",
  null
  
)

export default component.exports